import { Form } from 'react-bootstrap';

function BasicRequestInfoForm({ form, setForm, stepSubmitted }) {
  return (
    <>
      <div
        className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center flex-wrap mb-3"
        style={{ rowGap: '10px' }}
      >
        <div style={{ flex: 1.2, minWidth: '200px' }}>
          <Form.Group>
            <Form.Label>Required By Date</Form.Label>
            <Form.Control
              type="date"
              value={form.required_by_date}
              onChange={(e) => setForm({ ...form, required_by_date: e.target.value })}
              isInvalid={stepSubmitted && !form.required_by_date}
              min={new Date().toISOString().split('T')[0]}
            />
          </Form.Group>
        </div>

        <div style={{ flex: 1.4, minWidth: '170px' }}>
          <Form.Group>
            <Form.Label>Reason</Form.Label>
            <Form.Select
              value={form.reason}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
              isInvalid={stepSubmitted && !form.reason}
            >
              <option value="">Select reason</option>
              <option value="low stock">Low Stock</option>
              <option value="urgent requirement">Urgent Requirement</option>
            </Form.Select>
          </Form.Group>
        </div>

        <div style={{ flex: 1.4, minWidth: '170px' }}>
          <Form.Group>
            <Form.Label>Priority</Form.Label>
            <Form.Select
              value={form.priority}
              onChange={(e) => setForm({ ...form, priority: e.target.value })}
            >
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </Form.Select>
          </Form.Group>
        </div>


      </div>
        <div>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.notes}
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
            />
          </Form.Group>
        </div>
    </>
  );
}

BasicRequestInfoForm.validate = (form) => {
  if (!form.required_by_date || !form.reason) return false;
  // Ensure required_by_date is today or future
  const requiredDate = new Date(form.required_by_date);
  requiredDate.setHours(0,0,0,0);
  const today = new Date();
  today.setHours(0,0,0,0);
  return requiredDate >= today;
};

export default BasicRequestInfoForm;
